import { useQuery, useQueryClient } from "@tanstack/react-query";
import { listSetCategory } from "@api/products";

export const useCategoryListQuery = () => {
  const queryClient = useQueryClient();

  const division =
    typeof window !== "undefined"
      ? localStorage.getItem("categoryType") || "S"
      : "S";

  const queryKey = ["categoryList", division];

  const cached = queryClient.getQueryData(queryKey);

  return useQuery({
    queryKey,
    queryFn: async () => {
      // 이미 캐시에 있으면 API 호출하지 않음
      if (cached) return cached;

      const body = { modes: "ListSet", division };
      const res = await listSetCategory(body);

      if (res?.code === "0000") {
        return res.data || [];
      } else {
        throw new Error(res?.Msg || "카테고리 데이터를 불러올 수 없습니다.");
      }
    },
    enabled: typeof window !== "undefined",
    staleTime: Infinity, // 한 번 호출된 데이터는 항상 fresh로 간주
    cacheTime: Infinity,
  });
};
